/** CSV export for reconciliation reports (client-side, no server round-trip). */

function csvCell(value) {
  const s = value == null ? "" : String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

function downloadCsv(filename, rows) {
  const bom = "\uFEFF";
  const body = rows.map((row) => row.map(csvCell).join(",")).join("\r\n");
  const blob = new Blob([bom + body], { type: "text/csv;charset=utf-8" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}

/**
 * Export the currently visible project reconciliation rows.
 */
export function downloadReconciliationProjectsCsv(projects, { generatedAt } = {}) {
  const headers = [
    "Project code",
    "Project name",
    "Lifecycle status",
    "Overall status",
    "Issues",
    "Fund ledger (BDT)",
    "Expected cash (BDT)",
    "Cash delta (BDT)",
    "Shares sold",
    "Purchase ledger shares",
    "Shares sold delta",
    "Missing ledger rows",
    "Cap table match",
  ];
  const dataRows = (projects || []).map((p) => [
    p.project_code,
    p.project_name,
    p.status,
    p.overall_status || (p.has_issues ? "MISMATCHED" : "MATCHED"),
    (p.issue_labels || p.issue_codes || []).join("; "),
    p.fund_ledger_balance_bdt,
    p.expected_balance_including_adjustments_bdt,
    p.fund_ledger_delta_bdt,
    p.shares_sold,
    p.primary_purchase_shares_ledger,
    p.shares_sold_delta || "",
    p.missing_fund_ledger_entry_count,
    p.cap_table?.cap_table_matches_cap ? "YES" : "NO",
  ]);
  const stamp = generatedAt ? new Date(generatedAt).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10);
  downloadCsv(`reconciliation_projects_${stamp}.csv`, [headers, ...dataRows]);
}

/**
 * Export missing ledger transactions for one project (investigation worksheet).
 */
export function downloadProjectMissingLedgerCsv(detail) {
  if (!detail?.missing_fund_ledger_entries?.length) return false;
  const headers = ["Project code", "Transaction type", "Direction", "Amount BDT", "Reference ID", "Occurred at"];
  const dataRows = detail.missing_fund_ledger_entries.map((m) => [
    detail.project_code || detail.project_id,
    m.type,
    m.direction,
    m.amount_bdt,
    m.reference_id,
    m.at || "",
  ]);
  const code = (detail.project_code || "project").replace(/[^\w-]+/g, "_");
  downloadCsv(`${code}_missing_ledger_rows.csv`, [headers, ...dataRows]);
  return true;
}
